export const NavigationFonts = () => {
	const epicComponentDomain = process.env.EPIC_COMPONENTS_DOMAIN;

	return (
		<>
			<link rel="preconnect" href={epicComponentDomain} />
			<link rel="stylesheet" href={epicComponentDomain + '/styles/navigation.css'} />
		</>
	);
};
